import { render } from "./AppAvatar.vue?vue&type=template&id=edfed924&scoped=true"
import script from "./AppAvatar.vue?vue&type=script&lang=js"
export * from "./AppAvatar.vue?vue&type=script&lang=js"

import "./AppAvatar.vue?vue&type=style&index=0&id=edfed924&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edfed924"]])

export default __exports__